// Define action types
export const SET_TRAVEL_DETAILS = 'SET_TRAVEL_DETAILS';

// Define action creators
export const setTravelDetails = (formValues) => ({
  type: SET_TRAVEL_DETAILS,
  payload: formValues,
});
